/*
 *
 *  * Copyright(c) 2020 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccordionModule } from './accordion/accordion.module';
import { BadgeModule } from './badge/badge.module';
import { SelectGridModule } from './select-grid/select-grid.module';
import { DatePickerModule } from './date-picker/date-picker.module';
import { DropdownMenuModule } from './drop-down-menu/drop-down-menu.module';
import { DropdownModule } from './dropdown/dropdown.module';
import { EllipsisModule } from './ellipsis/ellipsis.module';
import { SelectDropdownModule } from './select-dropdown/select-dropdown.module';
import { TabsModule } from './tabs/tabs.module';
import { TimePickerModule } from './time-picker/time-picker.module';
import { HeaderModule } from './header/header.module';
import { TooltipModule } from './tooltip/tooltip.module';
import { PopoverModule } from './popover/popover.module';
import { InfinityScrollModule } from './infinity-scroll/infinity-scroll.module';
import { SpinnerModule } from './spinner/spinner.module';
import { SystemNotificationModule } from './system-notification/system-notification.module';
import { FilterTagModule } from './filter-tag/filter-tag.module';
import { TreeModule } from './tree/tree.module';
import { SwapListModule } from './swap-list/swap-list.module';
import { ToDoCountModule } from './to-do-count/to-do-count.module';
import { ScrollbarModule } from './scrollbar/scrollbar.module';
import { SelectPanelModule } from './select-panel/select-panel.module';
import { SelectFilterPanelModule } from './select-filter-panel/select-filter-panel.module';
import { IconsListModule } from './icons-list/icons-list.module';
import { BannerNotificationModule } from './banner-notification/banner-notifiction-module';
import { CardNotificationModule } from './card-notification/card-notification.module';
import { PatientBannerModule } from './patient-banner/patient-banner.module';
import { DatePickerRangeModule } from './date-picker-range/date-picker-range.module';
import { ButtonGroupModule } from './button-group/button-group.module';
import { FilterTagPanelModule } from './filter-tag-panel/filter-tag-panel.module';
import { VirtualListModule } from './virtual-list/virtual-list.module';
import { VirtualListDropdownModule } from './virtual-list-dropdown/virtual-list-dropdown.module';

@NgModule({
  exports: [
    AccordionModule,
    BadgeModule,
    ButtonGroupModule,
    DatePickerModule,
    DatePickerRangeModule,
    DropdownModule,
    DropdownMenuModule,
    EllipsisModule,
    IconsListModule,
    SelectDropdownModule,
    SelectGridModule,
    SelectPanelModule,
    SelectFilterPanelModule,
    TabsModule,
    TimePickerModule,
    HeaderModule,
    TooltipModule,
    PopoverModule,
    InfinityScrollModule,
    ScrollbarModule,
    SpinnerModule,
    SystemNotificationModule,
    FilterTagModule,
    FilterTagPanelModule,
    TreeModule,
    SwapListModule,
    ToDoCountModule,
    BannerNotificationModule,
    CardNotificationModule,
    PatientBannerModule,
    VirtualListModule,
    VirtualListDropdownModule
  ],
  imports: [CommonModule],
  declarations: []
})
export class ComponentsModule {}
